export default "__VITE_ASSET__BcHYfKFE__"